import Vue from "vue";
import Config from "../configuration";

export default {
    namespaced: true,
    mutations: {

    },
    getters: {

    },
    actions: {
        getTranslationsDictionary ()
        {
            let self = this;

            return new Promise(function (resolve, reject)
            {
                Vue.axios.get(Config.GetUrl(Config.translationsApi) + 'translation/KritaCustomer/' + self.state.i18n.locale + '/' + Config.translationServerDev ,{
                }).then(function (response)
                {
                        resolve(response.data);
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
    }
}
